// extracted by mini-css-extract-plugin
export default {"containerFeed":"orders_containerFeed__ty2Om","imgCardSmall":"orders_imgCardSmall__H0BHm","buttonCardSmall":"orders_buttonCardSmall__bbYDO"};